/* eslint-disable import/no-commonjs */
module.exports.offlineBuildStaticAssetDirectory = "dist";
